import React, { useRef, useContext } from 'react';
import './Statistics.scss';
import { WidthContext } from '../../WidthContext';
import graph from '../../assets/graph.png';

function Statistics3() {
  const width = useContext(WidthContext);
  const nums = [0, '200K', '400K', '600K', '800K', '1.0M', '1.2M', '1.4M', '1.6M', '1.8M'];
  const container = useRef();

  return (
    <figure className="statistics">
      <div className="statistics__graphic" ref={container}>
        <h3 className="statistics__graphic__title">Not Building Enough New Homes To Meet Demand</h3>
        <p className="statistics__graphic__copy">
          U.S. single family housing starts have lagged historical norms for fifteen years, leading
          to housing shortages in many areas.
        </p>

        <div className="statistics__graphic__graph statistics__graphic__graph-3">
          {width > 767 ? (
            <div className="statistics__graphic__graph__range statistics__graphic__graph__range-3">
              {[...Array(10)].map((num, i) => (
                <span key={i}>{(i * 200000).toLocaleString()}</span>
              ))}
            </div>
          ) : (
            <div className="statistics__graphic__graph__range statistics__graphic__graph__range-3">
              {nums.map((num, i) => (
                <span key={i}>{num}</span>
              ))}
            </div>
          )}

          <div className="statistics__graphic__graph__contents">
            <img alt="" src={graph} className="statistics__graph" />
            <div className="statistics__graphic__label statistics__graphic__label-3">
              {[...Array(11)].map((num, i) => (
                <span key={i}>{2000 + (i + 1) * 2}</span>
              ))}
            </div>
            <div className="statistics__scroll">
              Scroll{' '}
              <svg
                width="20"
                height="7"
                viewBox="0 0 20 17"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                className="statistics__scroll__arrow"
              >
                <path
                  d="M19.7512 8.20765L18.68 7.08547L12.151 0.22998L9.79437 2.47434L13.7016 6.57539H0.521118V9.83991H13.7016L9.79437 13.941L12.151 16.1853L18.68 9.32982L19.7512 8.20765Z"
                  fill="#004282"
                />
              </svg>
            </div>
          </div>
        </div>

        <div className="statistics__graphic__keys statistics__graphic__keys-3">
          <div className="statistics__graphic__key">
            <span className="statistics__graphic__key__color statistics__graphic__key__color-blue" />
            <span className="statistics__graphic__key__text">Historical Data</span>
          </div>
          <div className="statistics__graphic__key">
            <span className="statistics__graphic__key__color statistics__graphic__key__color-red" />
            <span className="statistics__graphic__key__text">Historical Average 1960-2022</span>
          </div>
        </div>
      </div>
      <figcaption className="captions">Source: NAR, 2022</figcaption>
    </figure>
  );
}

export default Statistics3;
